/** Calendar-date helpers for Deal Library (no timezone day-shift). */

const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * Normalize any deal date field to YYYY-MM-DD for <input type="date">.
 * Accepts ISO dates, ISO datetimes, and Swiss DD.MM.YYYY / DD/MM/YYYY.
 */
export function toDateInput(value) {
  if (value == null || value === '') return '';
  if (typeof value === 'string') {
    const s = value.trim();
    const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}`;
    const eu = s.match(/^(\d{1,2})[.\/](\d{1,2})[.\/](\d{4})$/);
    if (eu) {
      const day = eu[1].padStart(2, '0');
      const month = eu[2].padStart(2, '0');
      return `${eu[3]}-${month}-${day}`;
    }
    return '';
  }
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const y = value.getFullYear();
    const m = String(value.getMonth() + 1).padStart(2, '0');
    const d = String(value.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
  return '';
}

/** Display a date-only field as "30 Oct 2026" without UTC midnight shifting the day. */
export function formatDateOnly(dateStr) {
  const iso = toDateInput(dateStr);
  if (!iso) return '\u2014';
  const [y, m, d] = iso.split('-').map((x) => parseInt(x, 10));
  if (!y || !m || !d || m < 1 || m > 12) return '\u2014';
  return `${String(d).padStart(2, '0')} ${MONTHS_SHORT[m - 1]} ${y}`;
}

export function getDealYear(dateStr) {
  const iso = toDateInput(dateStr);
  return iso ? iso.slice(0, 4) : '';
}

/** Compare date fields for PATCH omit-if-unchanged (null == empty). */
export function sameCalendarDate(a, b) {
  const left = toDateInput(a) || null;
  const right = toDateInput(b) || null;
  return left === right;
}
